import { render, staticRenderFns } from "./SearchGalleryResults.vue?vue&type=template&id=207e93d6&scoped=true"
import script from "./SearchGalleryResults.vue?vue&type=script&lang=js"
export * from "./SearchGalleryResults.vue?vue&type=script&lang=js"
import style0 from "./SearchGalleryResults.vue?vue&type=style&index=0&id=207e93d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207e93d6",
  null
  
)

export default component.exports